import { render, staticRenderFns } from "./modal-reject-pickup.vue?vue&type=template&id=aba1bc1e"
import script from "./modal-reject-pickup.vue?vue&type=script&lang=js"
export * from "./modal-reject-pickup.vue?vue&type=script&lang=js"
import style0 from "./modal-reject-pickup.vue?vue&type=style&index=0&id=aba1bc1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports